import * as React from 'react'
import {SelectivePrintingContextValue} from './selectivePrinting.types'

export const SelectivePrintingContext = React.createContext<SelectivePrintingContextValue | null>(null)
